<gb-page-options-container>
  <gb-select-form-field
    labelTranslateKey="USER_ACCOUNTS.SEARCH_BY"
    [control]="searchByControl"
    [options$]="searchByOptions$"
    valueProperty="value"
    displayProperty="label"
    (onOptionSelected)="onSearchBySelected($event)"
  ></gb-select-form-field>
  <gb-search
    (searchTermEmit)="searchUserAccounts($event)"
    label="{{ searchLabel() }}"
    [searchHistory$]="searchHistory$"
    [entityName]="userAccountsEntityName"
    [loaded$]="loaded$"
  ></gb-search>
</gb-page-options-container>

<gb-table-grid
  (scrolled)="loadUserAccounts()"
  [totalItemCount]="count$ | async"
  icon="person"
  [displayedColumns$]="displayedColumns$"
  [tableData$]="allUserAccountsWithActions$"
  [loaded$]="loaded$"
  [dataView$]="dataView$"
  titleField="full_name"
  [hideFieldsOnCards]="['invite_first_name', 'invite_last_name']"
  [enableSort]="false"
  (sortChanged)="sortUserAccounts($event)"
>
</gb-table-grid>
